import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Response } from '../../../_shared/models/response.model';
import { CreateMaintenanceRequest, MaintenanceReason } from '../models/maintenance.model';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private httpClient = inject(HttpClient);

  async getMaintenanceReasons(cancelSubject: Subject<void>): Promise<Response<MaintenanceReason[]>> {
    return await firstValueFrom(
      this.httpClient.get(`${environment.apiEndpoint}/maintenanceoverview/maintenance-reasons`).pipe(takeUntil(cancelSubject))
    );
  }

  async createMaintenance(payload: CreateMaintenanceRequest): Promise<Response<boolean>> {
    return await firstValueFrom(
      this.httpClient.post(`${environment.apiEndpoint}/maintenanceoverview/create-maintenance`, payload)
    );
  }
}
